export default __webpack_public_path__ + "static/media/rescueservice.100f7ad0.png";